import * as localReferentielKeys from "./localReferentielKeys";

const localReferentielDummyData = {
  [localReferentielKeys.STATUS_SOUSCRIPTION_LOCAL_REFERENTIEL_KEY]: [
    {
      code: "VALIDEE",
      description: "Valide",
    },
    {
      code: "EXPIREE",
      description: "Expirée",
    },
    {
      code: "EN_INSTANCE_DE_PAIEMENT",
      description: "En instance de paiement",
    },
    {
      code: "SUSPENDU",
      description: "Suspendu",
    },
    {
      code: "ANNULEE",
      description: "Annulée",
    },
    {
      code: "EN_ATTENTE_CONFIRMATION_PAIEMENT",
      description: "En attente de confirmation paiement",
    },
  ],
  [localReferentielKeys.EXERCICE_SOUSCRIPTION_LOCAL_REFERENTIEL_KEY]: [
    {
      code: "EN_COURS",
      description: "Année en cours",
    },
    {
      code: "PROCHAIN",
      description: "Année prochaine",
    },
  ],
  [localReferentielKeys.PORT_SOUSCRIPTION_LOCAL_REFERENTIEL_KEY]: [
    {
      code: "AGADIR",
      description: "Agadir",
    },
    {
      code: "AL_HOCEIMA",
      description: "Al Hoceima",
    },
    {
      code: "CASABLANCA",
      description: "Casablanca",
    },
    {
      code: "DAMCO_LOGISTICS_MAROC",
      description: "DAMCO LOGISTICS MAROC",
    },
    {
      code: "DAKHLA",
      description: "Dakhla",
    },
    {
      code: "FORMATION",
      description: "Formation",
    },
    {
      code: "JADIDA",
      description: "Jadida",
    },
    {
      code: "JORF LASFAR",
      description: "Jorf Lasfar",
    },
    {
      code: "KENITRA",
      description: "Kenitra",
    },
    {
      code: "LAAYOUNE",
      description: "Laayoune",
    },
    {
      code: "MAPTM",
      description: "MAPTM",
    },
    {
      code: "MOHAMMEDIA",
      description: "Mohammedia",
    },
    {
      code: "NADOR",
      description: "Nador",
    },
    {
      code: "SAFIEC",
      description: "Safiec",
    },
    {
      code: "SAFI",
      description: "Safi",
    },
    {
      code: "SAFI_ATLANTIQUE",
      description: "Safi Atlantique",
    },
    {
      code: "TANTAN",
      description: "TanTan",
    },
    {
      code: "TANGER",
      description: "Tanger",
    },
    {
      code: "TANGER_MED",
      description: "TangerMed",
    },
  ],
};

export default localReferentielDummyData;
